import { render, staticRenderFns } from "./reviewermgt.vue?vue&type=template&id=2608196e"
import script from "./reviewermgt.vue?vue&type=script&lang=js"
export * from "./reviewermgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports